module.exports = "<script type=\"text/ng-template\" id=\"help-modal.html\">\n  <div class=\"modal-header\">\n  \t<div>\n  \t\t<center>\n  \t\t  <h3>{{ctrl.helpModal.name}}</h3>\n  \t\t</center>\n  \t</div>\n  </div>\n  <div class=\"modal-body\">\n  \t<div ng-bind-html=ctrl.helpModal.content></div>\n\n  </div>\n  <div class=\"modal-footer\">\n  \t\t<center>\n  \t\t\t  <button class=\"closeDescriptionbtn\" ng-click=\"ctrl.cancel()\">Close</button>\n  \t\t</center>\n  \t</div>\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/shared/directives/ag-grid-listing/help-modal/help-modal.html
// module id = 445
// module chunks = 0